
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import CryptoJS from 'crypto-js';
import Treeselect from '@riophae/vue-treeselect';
import CargoBookingServices from './../../../../cargobooking/services/cargobooking.service'
import MasterService from './../../../services/masterdata.service'
import porttoport from '../porttoport'
import CONSTANT from './../../../../shared/constants/constant'
import viewairratetemplate from './../viewairratetemplate'
import Util from './../../../../shared/util/util';
import versionView from './../airlineversion'
const moment = require('moment');
import XLSX from "xlsx";
export default {
	name: 'airwalletlisting',
	components: {
		Validator,
		Multiselect,
		Pagination,
		Loader,
		CustomExpandableTable,
		Treeselect,
		VueElementLoading,
		porttoport,
		viewairratetemplate,
		versionView
	},
	data: function () {
		return {
			showCreateroute: false,
			categoryName: null,
            categoryNameList:[],
			isLoading: false,
			status: null,
			tableColumn: ['Category', 'Created Date', 'Created by', 'Lastmodified Date', 'Lastmodified By','Versions', 'Status','Action'],
			innerTableColumn: [],
			tableItems: [],
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			offset: 0,
			pageLimit: CONSTANT.PER_PAGE_DATA,
			ShowAirlines: false,
			ShowviewVersion:false,
			AWB: "",
			tableArr: [],
			Clientlist: [],

			AssignedList: [],
			AssignedSR: null,
			companyName: null,
			shortcuts: false,
			daterange: "",

			defaultHubID: "",
			shortcuts: false,
			daterange: "",
			Statuslist: [
				{ id: '1', label: 'Active' },
				{ id: '0', label: 'Inactive' }
			],
			createdby: null,
			Createdbylist: [],
			pincode: '',

			routeid: '',
			routename: '',
			sr: '',
			clients: '',
			statusevent: '',
			hubnamelist: [],
			selectedHub: { value: '', text: '' },
			hubname: '',
			HubName: '',
			clientname: '',
			fmpincode: '',
			lmpincode: '',
			branchname: '',
			routestatus: '',
			selectedReqRouteObj: [],
			createdbyview: "",
			routeidview: "",
			dataForView : {},
			businesstype : 1,
			versionModal : false,

		}
	},

	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userdetail = userdetail;
		this.HubName = userdetail.currentHubName;
		this.userName = userdetail.email;
		this.defaultHubID = userdetail.hubID[0];
		this.userRoleFlag = (userdetail.rolename[0] == "Admin" || userdetail.rolename[0] == "Cargo Controlling Tower") ? 1 : 2;
		await this.getListingDataForPortToPort();
		this.getCategoryDataForPortToPort()
	},
	methods: {

		showCreateTemplate() {
			this.selectedReqRouteObj = {};
			this.selectedReqRouteObj.action = 'create'
			this.showCreateroute = true;
		},
		callParent() {
			this.showCreateroute = false;
			this.versionModal = false;
			this.selectedReqRouteObj = null;
			//this.currentPage = this.page;
			this.offset = 0;
		},
		resetFilter() {
			this.categoryName = null
			this.status = null
			this.getListingDataForPortToPort();
		},
		searchTemplate() {
			this.currentPage = 1;
			this.offset = 0;
			this.getListingDataForPortToPort();
		},
		async getCustomTableEvent(event) {
			if (event.actionType == "viewairline") {
				this.ShowAirlines = true;
			}
			if (event.actionType == "versions") {
				let objForViewData  = this.tableArr.filter(function(Items) {
					return Items.id == event.id;
				  });
				  this.dataForView = objForViewData[0];
				  this.versionModal = true;
			}
			if (event.actionType == "view") {

				let objForViewData  = this.tableArr.filter(function(Items) {
					return Items.id == event.id;
				  });
				  this.dataForView = objForViewData[0];
					this.ShowViewtemplate = true
				
			}

			if (event.actionType == "active") {
				this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
					this.activeAction(event);
				}).catch((err) => {
					console.log(err)
				});
			} else if (event.actionType == "inactive") {
				this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
					this.activeAction(event);
				}).catch((err) => {
					console.log(err)
				})
			}
		},
		async activeAction(data) {
			try {
				this.isLoading = true;
				var item = this.tableArr.find(item => item.id === data.id);
				var isactivestatus = data.actionType == 'inactive' ? 1 : 0
				let inputPayload = {
					"id": data.id,
					"status": isactivestatus,
					"username":this.userName,
					"remark":"Change Status"
				}
				  let result = await MasterService.changeCategotyStatus(inputPayload)
				if (result.data.code == 200 && result.data.data!=null) {
					if (result.data.data[0].status == 1) {
						this.$alert("Rate Template Inactivated  Successfully!", `${item.categoryname}`, "success");
					} else {
						this.$alert("Rate Template Activated Successfully!", `${item.categoryname}`, "success");
					}
					this.getListingDataForPortToPort();
					this.isLoading = false;
				}
				else{
					this.$alert(result.data.message, "error");
					this.isLoading = false;
				}
			} catch (err) {
				this.isLoading = false
			}
		},
		async getListingDataForPortToPort() {
			try {
				this.isLoading = true;
				let inputPayload = {
				}
                if(this.status)
				{
					inputPayload.status=this.status
				}
				if(this.categoryName)
				{
					inputPayload.categoryname=this.categoryName
				}
				let result = await MasterService.GetCategoryListingAndVersionDetails(inputPayload)
				if (result.data.code == 200) {
					this.tableArr = result.data.data;
					this.totalCount = result.data.data.length;
					this.tableItems = result.data.data.map((el) => {
						return {
							'id': el.id,
							'Category': el.categoryname,
							'Created Date':  Util.displayDateOnlyFormat(el.createddate),
							'Created by': el.createdby,
							'Lastmodified Date':  Util.displayDateOnlyFormat(el.lastmodifieddate),
							'Lastmodified By': el.lastmodifiedby,
							'Versions' : 'chk',
							'Status': el.status,
							'Action' : 'chk',
						}
					})
				} else {
					this.totalCount = 0
					this.tableItems = [];
				}
				if (this.totalCount < 10) {
					this.totalPage = 1
				} else {
					this.totalPage = Math.ceil(this.totalCount / 10);
				}
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
			}
		},
		onPageChange(page) {
			this.currentPage = page;
			this.offset = (page - 1) * this.pageLimit
			this.getRoutedata();
		},
		async getCategoryDataForPortToPort() {
			try {
				this.isLoading = true;
				let inputPayload = {
					// "offset": this.offset,
					// "limit": this.pageLimit,
				}
				let result = await MasterService.GetCategoryListingAndVersionDetails(inputPayload)
				if (result.data.code == 200) {
					result.data.data.forEach(el => {
						this.categoryNameList.push({
							'id': el.id,
							'label': el.categoryname
						})
					})
				} else {
					this.isLoading = false
					this.$alertify.error(result.data.message)
				}
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
			}
		},
		async exportData() {
			try {
				this.isLoading = true;
				let inputPayload = {
					// "offset": 0,
					// "limit": this.totalCount,
				}
				if (this.status) {
					inputPayload.status = this.status
				}
				if (this.categoryName) {
					inputPayload.categoryname = this.categoryName
				}
				let result = await MasterService.GetCategoryListingAndVersionDetails(inputPayload)
				if (result && result.data.code == 200) {
					var tempdata = [];
					var temp = result.data.data;
					if (temp.length > 0) {
						temp.forEach(el => {
							tempdata.push({
								'id': el.id,
								'Category': el.categoryname,
								'Created Date': Util.displayDateOnlyFormat(el.createddate),
								'Created by': el.createdby,
								'Lastmodified Date': Util.displayDateOnlyFormat(el.lastmodifieddate),
								'Lastmodified By': el.lastmodifiedby,
								'Status': el.status,
							});
						});
						let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
						const data1 = XLSX.utils.json_to_sheet(tempdata);
						const wb = XLSX.utils.book_new();
						XLSX.utils.book_append_sheet(wb, data1, 'data')
						XLSX.writeFile(wb, dt + '_PortToPortData.xlsx');
					}
					else {
						this.$alert("No records found", "", "error");
					}
				}
				else {
					this.$alert(result.data.message, "", "error");
					this.$alert("No records to download", "Error", "error");
				}
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
			}
		},
	},
}


// WEBPACK FOOTER //
// ./src/modules/masterdata/views/AirWalletTemplate/porttoportlisting/porttoportlisting.component.js